import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Messenger.svg",
  "use": "Messenger.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol viewBox=\"0 0 64 64\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"Messenger.svg\">\n<path d=\"M32.5 11C21.1789 11 12 19.4973 12 29.9813C12 35.957 14.9793 41.2802 19.6345 44.7652V52L26.6182 48.1699C28.4837 48.6824 30.4551 48.9626 32.5 48.9626C43.8211 48.9626 53 40.4636 53 29.983C53 19.5024 43.8211 11 32.5 11ZM34.5346 36.5618L29.3157 30.9926L19.1289 36.5618L30.3338 24.6667L35.6826 30.2341L45.743 24.6667L34.5346 36.5618Z\" fill=\"black\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol